  <template>
  <NavBar pageName="UsersView"></NavBar>
  <!--  <div>{{token}}</div>-->
  <!--  <div>{{user}}</div>-->
  <div style="margin-top: 185px;"></div>
  <!--  <AddNewUser @showAddNewUserEvent="setShowAddNewUser" ></AddNewUser>-->
  <div v-if="computedShowUsersList" class="pl-10">
    <!-- Title and Add New User Button -->
    <div class="page-header">
      <h1>Add new user view</h1>
    </div>


  </div>
  <AddNewUser @showAddNewUserEvent="setShowAddNewUser" @cancelAddNewUserEvent="setShowUsersList" v-if="showComputedFinalAddNewUser"></AddNewUser>


</template>

<script>
import { defineComponent } from 'vue';
import useGetLoggedIn from "@/composables/useGetLoggedIn"
import {log} from "@/composables/useLog";
import NavBar from "@/components/NavBar.vue";
// import UsersList from "@/components/UsersList.vue";
import store from "@/store";
import axios from 'axios'
// import { useRouter } from 'vue-router'
import {BASE_URL}from "@/composables/url_config";
import useGetClientsAPI from "@/composables/useGetClientsAPI";
// Components
import useGetUserRoles from "@/composables/useGetUserRoles";
import AddNewUser from "@/components/AddNewUser.vue";

export default defineComponent({
  name: 'UsersView',
  components: {
    // UsersList,
    AddNewUser,
    NavBar
  },
  data() {
    return {
      showToken:false,
      showUsersList:false,
      showAddNewUserComp:true,
      token:'',
      user:null,
      usersListLoaded:true,
      currentView:null,
      users: [], // User data fetched from the backend
      searchQuery: "",
      rolesMenuOpen: false,
      detailsDialogOpen: false,
      selectedUser: null,
      userRoles: [], // Roles of the currently selected user
      clientsLoadedForNewUser:true,
    }
  },
  computed: {
    filteredUsers() {
      return this.users.filter((user) => {
        const query = this.searchQuery.toLowerCase();
        return (
            user.name.toLowerCase().includes(query) ||
            user.username.toLowerCase().includes(query) ||
            user.email.toLowerCase().includes(query) ||
            user.phone?.toLowerCase().includes(query)
        );
      });
    },
    showComputedFinalAddNewUser() {
      if(this.showAddNewUserComp && this.clientsLoadedForNewUser){
        return true
      } else{
        return false
      }
    },
    computedShowUsersList() {
      // alert("am primit emisia")
      if (this.usersListLoaded &&  this.showUsersList){
        return true
      }else{
        return false
      }
    },
  },
  methods: {
    setShowUsersList(){
      this.showAddNewUserComp=false
      this.showUsersList=true
    },

    openAddNewUser() {
      // Open the <AddNewUser> component
      log("facem showAddNewUserComp=true")
      this.showAddNewUserComp=true
      this.showUsersList=false
    },
    setShowAddNewUser() {
      log("chemam  setShowAddNewUser")
      this.clientsLoadedForNewUser=true
      this.showUsersList=false

    },
    openRolesMenu(user) {
      this.selectedUser = user;
      store.commit('setSelectedUser',  this.selectedUser)
      this.rolesMenuOpen = true;
      this.callGetUserRoles();
    },
    goToUserDetailsView(user) {
      // alert(user.id)
      this.selectedUser = user;
      store.commit('setSelectedUser', user)
      // const router=useRouter()
      this.$router.push({ name: 'userDetails' });
    },
    closeRolesMenu() {
      this.rolesMenuOpen = false;
      this.selectedUser = null;
    },
    async callGetUserRoles() {
      const {getUserRoles}=useGetUserRoles()
      getUserRoles(this.token,this.user.id).then((response)=>{
        this.userRoles = response.user_roles;
      })
    },
    async toggleRole(roleId) {
      try {
        const headers = {
          Authorization: `Bearer ${this.token}`,
          "Content-Type": "application/json",
          role_id:roleId
        };
        const url=BASE_URL+'/api/v1/home/toggleUserRole'
        const response = await axios.post(url, {}, { headers });
        this.userRoles = response.user_roles;
      } catch (error) {
        console.error("Error toggling role:", error);
      }
    },
    showMoreDetails(user) {
      this.selectedUser = user;
      this.detailsDialogOpen = true;
    },
    closeDetailsDialog() {
      this.detailsDialogOpen = false;
      this.selectedUser = null;
    },
  },
  created() {
    const {getLoggedIn, user, loggedIn, userAvatar,token}=useGetLoggedIn()
    const {getClientUsers}=useGetClientsAPI()
    getLoggedIn().then(()=>{
      // timestamp("autorizare in HomeloggedIn after getLoggedIn")
      log ("dupa created in Dashboard avem:")
      log("autorizare in Dashboard after getLoggedIn")
      log("user:")
      log(user)
      log("loggedIn: " + loggedIn.value)
      log("token: " + token.value)
      log("userAvatar: " + userAvatar)
      this.token=token.value
      this.user=user.value
      store.commit('setCurrentView',this.currentView)
      getClientUsers(this.token,this.user.client_id).then((result)=>{
        this.users=result.users
      })
      // this.showToken=true
    })
  }
});
</script>
